import React from "react";
import Routes from "./Routes";
import { Toaster } from "./components/ui/Toaster";

function App() {
  return (
    <>
      <Routes />
      <Toaster />
    </>
  );
}

export default App;
